import apiClient from "@/api/axiosClient";
import type { AuthResponse } from "@/api/auth";

export interface TeamMember {
  id: string;
  email?: string;
  displayName?: string;
  role?: string;
  isPending: boolean;
}

export interface InviteTeammatePayload {
  email: string;
  displayName?: string;
  role?: string;
}

export interface InviteResponse {
  email: string;
  token: string;
}

export interface AcceptInvitePayload {
  email: string;
  token: string;
  password: string;
}

export async function fetchTeam(): Promise<TeamMember[]> {
  const { data } = await apiClient.get<TeamMember[]>("/team");
  return data;
}

export async function inviteTeammate(payload: InviteTeammatePayload): Promise<InviteResponse> {
  const { data } = await apiClient.post<InviteResponse>("/team/invite", payload);
  return data;
}

export async function acceptInvite(payload: AcceptInvitePayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/team/accept-invite", payload);
  return data;
}
